<template>
    <div class="page-container">
        <div class="page-wrapper">
            <img src="../../assets/track-qs-light.png" alt="">
            <div class="result-txt">操作成功</div>
            <div class="aside-txt">您已操作成功，返回首页进行其他操作</div>
            <div class="btn-back" @click="jumpPage('index')">返回首页</div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        jumpPage(name){
            this.$router.push({
                name:name
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.page-container{
    padding:15px;
    background:#fafafa;
    min-height: 100vh;
    box-sizing: border-box;
    .page-wrapper{
        background:#fff;
        border-radius: 4px;
        overflow: hidden;
        text-align: center;
        padding:0 20px;
        &>img{
            width:60px;
            height:60px;
            margin-top: 36px;
            margin-bottom: 20px;
        }
        .result-txt{
            color:#333;
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
            margin-bottom: 10px;
        }
        .aside-txt{
            color:#666;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 35px;
        }
        .btn-back{
            width:180px;
            margin:0 auto;
            border-radius: 26px;
            text-align: center;
            height:40px;
            line-height: 40px;
            font-size: 16px;
            color:#fff;
            margin-bottom: 30px;
            background: linear-gradient(180deg, #55B3FF 0%, #3189F6 100%);
        }
    }
}
</style>